// import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Advt from './components/Advt/Advt';
import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import plashka1 from './assets/images/plashka1.png';
import plashka2 from './assets/images/plashka2.png';

import { useMemo, useRef } from 'react';
import { AnimatePresence, motion } from 'motion/react';

function App() {
  const {
    currentState,
    isVisible,
    currentMessage,
    messageAnimationTrigger,
    setDelay,
  } = useBroadcast();

  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    bgColor,
    user,
    variantPlashka,
  } = useGetParams();

  const bgPlashka = variantPlashka === '1' ? plashka1 : plashka2;

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg, bgColor]);

  // контейнер с сообщением, нужен для скролинга текста сообщения в useScrollText
  const messagesRef = useRef(null);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AnimatePresence mode="wait">
        {isVisible && currentState === 'S1' && (
          <motion.div
            className="bg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{ backgroundImage: `url(${bgPlashka})` }}
          />
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {isVisible && currentState === 'S1' && (
          <motion.div
            style={{ width: '100%' }}
            key={currentState}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.5 }}
          >
            <div className="titre-wrapper" ref={messagesRef}>
              <div className="message-wrapper">
                <Message
                  message={currentMessage?.message || {}}
                  setDelay={setDelay}
                  messagesWrapper={messagesRef.current}
                  user={user}
                  currentState={currentState}
                />
              </div>

              <Advt className="titre-advt" advtInfo={advt_info} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      {/* <CSSTransition
        in={isVisible && currentState === 'S1'}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
        nodeRef={messagesRef}
      >
        <div className="titre-wrapper" ref={messagesRef}>
          <div className="message-wrapper">
            <CSSTransition
              in={currentMessage && currentState === 'S1'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit
            >
              <SwitchTransition>
                <CSSTransition
                  key={messageAnimationTrigger}
                  addEndListener={(node, done) => {
                    node.addEventListener('transitionend', done, false);
                  }}
                  classNames="fade"
                >
                  <Message
                    message={currentMessage?.message || {}}
                    setDelay={setDelay}
                    messagesWrapper={messagesRef.current}
                    user={user}
                  />
                </CSSTransition>
              </SwitchTransition>
            </CSSTransition>
          </div>
          <CSSTransition
            in={currentState === 'S1'}
            timeout={500}
            classNames="fade-scale"
            unmountOnExit
          >
            <Advt className="titre-advt" advtInfo={advt_info} />
          </CSSTransition>
        </div>
      </CSSTransition> */}
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
